import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-258">
      <div className="max-w-4xl mx-auto px-4" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-260">
          {/* Opening Hook */}
          <div className="relative mb-12" data-id="element-261">
            <LeafIcon className="absolute -left-8 top-0 w-6 h-6 text-[#5B8F7B]/30 hidden md:block" data-id="element-262" />
            <p className="text-lg md:text-xl text-[#2D3436] leading-relaxed" data-id="element-263">
              Te despiertas con el vientre plano, pero a las 4 de la tarde no
              soportas el botón de tu pantalón. Te miras al espejo y no
              entiendes por qué, si te cuidas y caminas, tu abdomen parece un
              globo inflado que no cede ante nada.
            </p>
          </div>

          {/* Highlighted statement */}
          <div className="bg-[#5B8F7B]/5 border-l-4 border-[#5B8F7B] p-6 rounded-r-xl mb-12" data-id="element-264">
            <p className="text-xl md:text-2xl font-['Playfair_Display'] text-[#2D3436] italic" data-id="element-265">
              No es grasa acumulada. Es{' '}
              <span className="text-[#5B8F7B] font-semibold not-italic" data-id="element-266">
                inflamación por cortisol
              </span>
              . Y después de los 30 años, las reglas del juego para tu cuerpo
              han cambiado por completo.
            </p>
          </div>

          {/* The Problem */}
          <div className="space-y-6" data-id="element-267">
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-semibold text-[#2D3436] flex items-center gap-3" data-id="element-268">
              <span className="w-12 h-[2px] bg-[#C4A962]" data-id="element-269"></span>
              El Problema Real
            </h3>

            <p className="text-lg text-[#2D3436]/80 leading-relaxed" data-id="element-270">
              Has intentado comer menos. Has intentado correr más. Pero lo único
              que logras es sentirte más agotada y ver cómo tu vientre se
              ensancha cada vez que tienes una semana estresante en el trabajo o
              con la familia.
            </p>

            <p className="text-lg text-[#2D3436]/80 leading-relaxed" data-id="element-271">
              El problema es que el estrés crónico le ordena a tu cuerpo{' '}
              <em className="text-[#5B8F7B] font-medium" data-id="element-272">
                retener agua y proteger tus órganos con una capa de inflamación
                dura
              </em>
              . Mientras más te esfuerzas con dietas restrictivas, más cortisol
              produces, y más se infla tu abdomen.
            </p>

            <p className="text-lg text-[#2D3436] font-medium bg-[#FBF9F4] p-4 rounded-xl" data-id="element-273">
              Estás atrapada en un ciclo de "supervivencia hormonal" que el
              cardio tradicional solo empeora.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}